import { render, staticRenderFns } from "./GenericControlHistory.vue?vue&type=template&id=0d357ad2&"
import script from "./GenericControlHistory.vue?vue&type=script&lang=js&"
export * from "./GenericControlHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports